module.exports = __webpack_public_path__ + "img/img12.50e42e1f.jpg";